"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const URLs_1 = require("../utility/URLs");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const PageContentRender_1 = __importDefault(require("../components/PageContentRender"));
const react_bootstrap_1 = require("react-bootstrap");
const helpers_1 = require("../../commonFiles/helpers");
const ChangePageTitle_1 = __importDefault(require("../../commonFiles/ChangePageTitle"));
function PageShow(props) {
    let { id } = (0, react_router_1.useParams)();
    const [page, setpage] = react_1.default.useState(null);
    function setup() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield URLs_1.Api.fetchPage(id);
                setpage(response.data);
                console.log('fetchPage', response.data);
            }
            catch (error) {
                (0, helpers_1.logError)(error, 'fetchPage');
            }
        });
    }
    react_1.default.useEffect(() => {
        setup();
    }, []);
    const [render, setrender] = react_1.default.useState('original');
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(ChangePageTitle_1.default, { pageTitle: page === null || page === void 0 ? void 0 : page.title }),
        react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.pageEdit(id) }, "edit"),
        react_1.default.createElement("h5", { className: 'text-center' },
            "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0635\u0641\u062D\u0629 ", page === null || page === void 0 ? void 0 :
            page.title),
        react_1.default.createElement("div", { className: 'text-center' },
            "\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0635\u062F\u0631 ",
            react_1.default.createElement("a", { href: page === null || page === void 0 ? void 0 : page.source_url, target: '_blank' }, page === null || page === void 0 ? void 0 : page.source_url)),
        react_1.default.createElement("div", { className: 'text-center' },
            "\u064A\u0646\u062A\u0645\u064A \u0644\u0644\u0643\u062A\u0627\u0628 ",
            react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.bookShow(page === null || page === void 0 ? void 0 : page.book_id) }, page === null || page === void 0 ? void 0 : page.book_id)),
        react_1.default.createElement("div", { className: 'text-center' },
            "\u062D\u0648\u0644 \u0627\u0644\u0635\u0641\u062D\u0629 ", page === null || page === void 0 ? void 0 :
            page.about),
        react_1.default.createElement("div", { className: 'text-center' },
            "\u0648\u0635\u0641 \u0627\u0644\u0635\u0641\u062D\u0629 ", page === null || page === void 0 ? void 0 :
            page.description),
        react_1.default.createElement("div", { className: 'text-center' },
            " \u0647\u0644 \u0645\u062A\u0631\u062C\u0645\u0629 ",
            (page === null || page === void 0 ? void 0 : page.isTranslated) ? 'نعم' : 'لا'),
        react_1.default.createElement("div", { className: 'text-center' },
            "\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0646\u0635 \u0627\u0644\u0627\u0635\u0644\u064A ", page === null || page === void 0 ? void 0 :
            page.page_content.originalDir),
        react_1.default.createElement("div", { className: 'text-center' },
            "\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645 ", page === null || page === void 0 ? void 0 :
            page.page_content.translatedDir),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => setrender('original') }, "\u0639\u0631\u0636 \u0627\u0644\u0646\u0635 \u0627\u0644\u0627\u0635\u0644\u064A"),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => setrender('translated') }, "\u0639\u0631\u0636 \u0627\u0644\u062A\u0631\u062C\u0645\u0629"),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => setrender('both') }, "both"),
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
            react_1.default.createElement(PageContentRender_1.default, { pageContent: page === null || page === void 0 ? void 0 : page.page_content, render: render }))));
}
exports.default = PageShow;
